import { useEffect, useRef } from 'react';

import { useAnalytics } from '@townsquare/analytics';
import { setFavicon } from '@townsquare/dynamic-favicon';
import { useRovoAppification } from '@townsquare/rovo/appification';
import { useRovoEntitlement } from '@townsquare/rovo/entitlement';

export const RovoAppificationHandler = () => {
	const { rovoAppificationState } = useRovoAppification();
	const rovoEntitlement = useRovoEntitlement();
	const analytics = useAnalytics();
	const hasFiredRef = useRef(false);

	useEffect(() => {
		if (hasFiredRef.current) {
			return;
		}

		if (rovoAppificationState !== 'loading' && !rovoEntitlement.loading && rovoEntitlement.data) {
			const homeAppType = rovoAppificationState === 'enabled' ? 'rovo' : 'classic';

			void analytics.setTopLevelAttributes({
				homeAppType,
			});

			void analytics.operational('homeApp', 'loaded', {
				isRovoEnabled: rovoEntitlement.data.isRovoEnabled,
				isRovoLLMEnabled: rovoEntitlement.data.isRovoLLMEnabled,
				rovoAppification: rovoAppificationState === 'enabled',
			});

			hasFiredRef.current = true;

			if (rovoAppificationState === 'enabled') {
				setFavicon('rovo');
			} else {
				setFavicon('home');
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		rovoAppificationState,
		rovoEntitlement.loading,
		rovoEntitlement.data?.isRovoEnabled,
		rovoEntitlement.data?.isRovoLLMEnabled,
	]);

	return null;
};
